import { Alert, SkeletonRows } from "@station/ui";
import { createFileRoute } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { ProgramForm } from "../../../features/loyalty/program-form.js";
import { useLoyaltyPermissions, useLoyaltyProgram } from "../../../features/loyalty/queries.js";
import { LoyaltyPage } from "../../../features/loyalty/shared.js";
import { errorMessage } from "../../../lib/errors.js";

export const Route = createFileRoute("/_app/sadakat/program")({ component: ProgramRoute });

/** Sadakat programı ve markası (ADR 0017 §18): form + müşteri uygulaması kartının canlı önizlemesi. */
function ProgramRoute(): ReactElement {
  const { t } = useTranslation();
  const permissions = useLoyaltyPermissions();
  const program = useLoyaltyProgram(permissions.enabled && permissions.canRead);
  return (
    <LoyaltyPage title={t("menu.loyaltyProgram")} description={t("loyalty.program.description")}>
      {program.error ? (
        <Alert tone="danger">{errorMessage(program.error)}</Alert>
      ) : !program.data ? (
        <SkeletonRows rows={10} />
      ) : (
        <ProgramForm program={program.data} />
      )}
    </LoyaltyPage>
  );
}
